<section class="pl-20 flex items-center">
  <div
    class="box bg-white rounded flex flex-col items-center justify-center p-16"
  >
    <h1 class="title text-3xl font-medium">Canvas Admin</h1>
    <p class="text-center">
      Your user does not have valid permissions to access this site.
    </p>
    <button
      (click)="logout()"
      class="button button-primary w-full text-white mt-10"
      type="submit"
    >
      Logout
    </button>
  </div>
</section>
